module.exports = __webpack_public_path__ + "img/casesnopposcan.753588d0.png";